var _defs, _path, _polyline, _line, _polyline2, _polyline3, _polyline4, _polyline5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54.97,19.87s8.78-11.79,19.77-14.54,18.62,2.04,22.08,6.21,5.81,8.8,7.36,14.27c1.68,5.94,1.06,14.36-.8,19.86s-6.69,16.8-19.06,31.12c-11.26,13.03-30.08,26.69-30.08,26.69,0,0-15.14-12.59-16.29-13.65s-11.61-11.97-13.48-14.01S9.13,57.11,6.03,45.14c-3.1-11.97-1.94-25.62,7.36-33.87,8.44-7.49,15.83-7.86,21.72-6.21,6.46,1.81,14.45,7.36,19.86,14.81Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "13.39 11.27 39.6 18.94 54.97 19.87 69.75 19 96.82 11.54 91.44 30.67 103.38 45.67 83.3 56.83 66.04 62.37 54.83 72.71 46.41 78.41 24.47 75.82 25.77 56.72 32.8 46.05 32.24 27.85 39.6 18.94 35.11 5.07"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.31,
    y1: 25.55,
    x2: 17.42,
    y2: 30.23
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "104.18 25.81 91.44 30.67 76.17 46.1 66.04 62.37 62.5 78.8 54.24 103.48 46.41 78.41 32.8 46.05 17.64 30.23 6.09 45.37 25.77 56.72 43.75 62.64 54.83 72.71 62.5 78.8"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "74.74 5.33 69.75 19 76.83 27.9 76.17 46.1 83.3 56.83 84.32 76.79 62.5 78.8 70.66 90.26"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "32.8 46.05 43.75 62.64 46.41 78.41 37.95 89.83"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "91.44 30.67 76.83 27.9 54.97 19.87 32.24 27.85 17.42 30.23 13.39 11.53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0a337eabe99aef66c1220d2210821201.svg";
export { ForwardRef as ReactComponent };